import { v4 as uuidv4 } from '../lib/uuid'
import { AsyncStorage, Platform } from 'react-native'
import { RESET, updateGameId, getGames } from '../redux/game'
import { fetchContent } from '../redux/content'

import api from '../services/api'
import adminApi from '../services/admin-api'
import { teamChange } from './team'

const DEVICE_SETUP_STORAGE_KEY = '@ascension:device:1'
const PARTICIPANT_DETAILS_STORAGE_KEY = '@ascension:participant:details:2'

// Actions
export const DEVICE_STATUS_CHECKED = 'ascension/device/status-checked'
const REGISTER_DEVICE_START = 'ascension/register-device/fetching'
export const REGISTER_DEVICE_SUCCESS = 'ascension/register-device/success'
const REGISTER_DEVICE_ERROR = 'ascension/register-device/error'
const INIT_DEVICE_ID = 'ascension/device/init'
const UPDATE_HAS_SETUP_INFO = 'ascension/device/update_setup_info'
const DEVICE_CONNECTION_UPDATE = 'ascension/device/connection'
const DEVICE_NETWORK_CONNECTION_UPDATE = 'ascension/device/network_connection'
const UPDATE_HOSTNAME = 'ascension/device/update_hostname'
export const DEVICE_UNREGISTER = 'ascension/device/unregister'
const PARTICIPANT_DETAILS = 'ascension/device/participant_details'
const UPDATE_HOST = 'ascension/device/update_host'
const SET_MASTER_STATUS = 'ascension/device/set_master_status'

export const getHostname = ({ hostType, hostEnv, hostRole }) => {
  if (hostType === 'online') {
    if (hostEnv === 'live') {
      return 'https://api.banksim.co'
    }
    return 'https://test-api.banksim.co'
  } else {
    if (hostEnv === 'live') {
      if (hostRole === 'primary') {
        return 'http://10.0.0.99:3000'
      }
      return 'http://10.0.0.98:3000'
    } else {
      if (hostRole === 'primary') {
        return 'http://10.0.0.99:3001'
      }
      return 'http://10.0.0.98:3001'
    }
  }
}

let hostType = 'offline'
let hostname = getHostname({ hostType: 'offline', hostEnv: 'live', hostRole: 'primary' })
if (process.env.REACT_NATIVE_HOST_IP_ADDR) {
  hostType = 'manual'
  hostname = `http://${process.env.REACT_NATIVE_HOST_IP_ADDR}:3000`
}

// Reducer
const initialState = {
  networkConnected: false,
  hostname: hostname,
  connected: false,
  registered: false,
  registering: false,
  deviceStatusChecked: false,
  error: null,
  deviceId: null,
  isMaster: false,
  initialised: false,
  hasSetupInfo: false,
  participantDetails: null,
  hostType,
  hostEnv: 'live',
  hostRole: 'primary'
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case DEVICE_NETWORK_CONNECTION_UPDATE: {
      return {
        ...state,
        networkConnected: action.data
      }
    }
    case DEVICE_STATUS_CHECKED: {
      return {
        ...state,
        deviceStatusChecked: true
      }
    }
    case DEVICE_CONNECTION_UPDATE: {
      return {
        ...state,
        connected: action.data
      }
    }
    case REGISTER_DEVICE_START: {
      return {
        ...state,
        registering: true,
        registered: false,
        error: null
      }
    }
    case DEVICE_UNREGISTER: {
      return {
        ...state,
        registered: false
      }
    }
    case REGISTER_DEVICE_SUCCESS: {
      return {
        ...state,
        registering: false,
        registered: true,
        connected: true,
        deviceId: action.data.deviceId,
        isMaster: action.data.isMaster,
        error: null,
        hasSetupInfo: true
      }
    }
    case REGISTER_DEVICE_ERROR: {
      return {
        ...state,
        registered: false,
        registering: false,
        error: action.data
      }
    }
    case INIT_DEVICE_ID: {
      return {
        ...state,
        deviceId: action.data,
        initialised: true
      }
    }
    case UPDATE_HOSTNAME: {
      return {
        ...state,
        hostname: action.data
      }
    }
    case UPDATE_HAS_SETUP_INFO: {
      return {
        ...state,
        hasSetupInfo: action.data
      }
    }
    case PARTICIPANT_DETAILS: {
      return {
        ...state,
        participantDetails: action.data
      }
    }
    case UPDATE_HOST: {
      return {
        ...state,
        hostType: action.data.hostType,
        hostEnv: action.data.hostEnv,
        hostRole: action.data.hostRole,
        hostname: action.data.hostname
      }
    }
    case SET_MASTER_STATUS: {
      return {
        ...state,
        isMaster: action.data
      }
    }
    case RESET: {
      return {
        ...initialState,
        deviceId: state.deviceId,
        initialised: state.initialised,
        hasSetupInfo: state.hasSetupInfo,
        hostType: state.hostType,
        hostEnv: state.hostEnv,
        hostRole: state.hostRole,
        hostname: state.hostname
      }
    }
    default:
      return state
  }
}

export default reducer

export function registerDeviceStart () {
  return {
    type: REGISTER_DEVICE_START
  }
}

export function registerDeviceSuccess (data) {
  return {
    type: REGISTER_DEVICE_SUCCESS,
    data
  }
}

export function registerDeviceError (error) {
  return {
    type: REGISTER_DEVICE_ERROR,
    data: error
  }
}

export function initDeviceId (deviceId) {
  return {
    type: INIT_DEVICE_ID,
    data: deviceId
  }
}

export function updateSetupInfo (hasSetupInfo) {
  return {
    type: UPDATE_HAS_SETUP_INFO,
    data: hasSetupInfo
  }
}

export function deviceConnectionUpdate (connected) {
  return {
    type: DEVICE_CONNECTION_UPDATE,
    data: connected
  }
}

export function deviceNetworkConnectionUpdate (connected) {
  return {
    type: DEVICE_NETWORK_CONNECTION_UPDATE,
    data: connected
  }
}

export function updateHostName (hostname) {
  return {
    type: UPDATE_HOSTNAME,
    data: hostname
  }
}

export function updateHost (data) {
  return {
    type: UPDATE_HOST,
    data
  }
}

export function unregister () {
  return {
    type: DEVICE_UNREGISTER
  }
}

export function participantDetails (details) {
  return {
    type: PARTICIPANT_DETAILS,
    data: details
  }
}

export function deviceStatusChecked () {
  return {
    type: DEVICE_STATUS_CHECKED
  }
}

export function setMasterStatus (isMaster) {
  return {
    type: SET_MASTER_STATUS,
    data: isMaster
  }
}

// Action Creators
export function onHostChange (data) {
  return async dispatch => {
    console.log('onHostChange', data)
    dispatch(updateHost(data))
    dispatch(getGames(data.hostname))
    const store = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
    await AsyncStorage.setItem(
      DEVICE_SETUP_STORAGE_KEY,
      JSON.stringify({
        ...store,
        ...data
      })
    )
    api.setHost(data.hostname)
  }
}

export function registerDevice (deviceId, team, isMaster, sideBarFontSize, gameId, { retryAsNonMaster } = {}) {
  gameId = gameId || api.gameId
  return async (dispatch, getState) => {
    dispatch(registerDeviceStart())
    const deviceSetupDetails = { gameId, deviceId, team, isMaster, sideBarFontSize, hostname: getState().device.hostname, hostType: getState().device.hostType, hostEnv: getState().device.hostEnv, hostRole: getState().device.hostRole }
    try {
      const currentTeamId = getState().team.id
      api.setGameId(gameId)
      let response
      try {
        response = await api.registerDevice(deviceId, team, isMaster, sideBarFontSize)
      } catch (e) {
        if (retryAsNonMaster && e.code === 422 && e.message === 'This team already has a master device') {
          response = await api.registerDevice(deviceId, team, false, sideBarFontSize)
          deviceSetupDetails.isMaster = false
        } else {
          throw e
        }
      }
      // if (Platform.OS === 'web') {
      //   window.history.replaceState({}, document.title, window.location.href.replace(window.location.search, ''))
      // }
      await AsyncStorage.setItem(DEVICE_SETUP_STORAGE_KEY, JSON.stringify(deviceSetupDetails))
      if (currentTeamId && currentTeamId !== team) {
        dispatch(teamChange({ id: team }))
      }
      dispatch(registerDeviceSuccess(response))
      dispatch(fetchContent())
    } catch (e) {
      if (Platform.OS === 'web' && (e.code === 403 || (e.code === 422 && e.message === 'The game has not been setup yet'))) {
        await AsyncStorage.setItem(DEVICE_SETUP_STORAGE_KEY, JSON.stringify(deviceSetupDetails))
        dispatch(updateSetupInfo(true))
      }
      dispatch(registerDeviceError(e))
    }
  }
}

export function checkIfEventClosed () {
  return async (dispatch, getState) => {
    if (Platform.OS === 'web' && getState().device.participantDetails && !getState().device.participantDetails.eventClosed) {
      await getParticipantDetails({ dispatch, getState }, getState().device.participantDetails)
    }
  }
}

export function reRegisterDevice (gameId) {
  return async (dispatch, getState) => {
    dispatch(registerDeviceStart())

    try {
      const store = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
      const { deviceId, team, isMaster, sideBarFontSize, hostname, hostType, hostEnv, hostRole } = JSON.parse(store)
      if (hostname) {
        dispatch(updateHost({ hostname, hostType, hostEnv, hostRole }))
        api.setHost(hostname)
        dispatch(getGames(hostname))
      } else {
        const { hostname, hostType, hostEnv, hostRole } = getState().device
        dispatch(updateHost({ hostname, hostType, hostEnv, hostRole }))
        api.setHost(hostname)
        dispatch(getGames(hostname))
      }
      api.setGameId(gameId)
      dispatch(updateGameId(gameId))
      const response = await api.registerDevice(deviceId, team, isMaster, sideBarFontSize)
      dispatch(registerDeviceSuccess(response))
      dispatch(fetchContent())
      await AsyncStorage.setItem(DEVICE_SETUP_STORAGE_KEY, JSON.stringify({ deviceId, team, isMaster, sideBarFontSize, hostname, hostType, hostEnv, hostRole, gameId }))
    } catch (e) {
      dispatch(registerDeviceError(e))
    }
  }
}

export async function appHasBecomeActive (store) {
  try {
    let deviceSetup = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
    deviceSetup = JSON.parse(deviceSetup)
    const { hostname, hostType, hostEnv, hostRole, gameId, deviceId } = deviceSetup
    store.dispatch(updateHost({ hostname, hostType, hostEnv, hostRole }))
    api.setHost(hostname)
    store.dispatch(getGames(hostname))
    api.setGameId(gameId)
    store.dispatch(updateGameId(gameId))
    if (deviceId && gameId && deviceSetup.team) {
      store.dispatch(updateSetupInfo(true))
    }
  } catch (e) {}
}

const getParticipantDetails = async (store, { participantId, environment, eventId }) => {
  const details = await adminApi.getParticipantDetails({ participantId, environment, eventId })
  const participantDetailsToSave = { ...details, environment }
  await AsyncStorage.setItem(PARTICIPANT_DETAILS_STORAGE_KEY, JSON.stringify(participantDetailsToSave))
  store.dispatch(updateHost({ hostname: details.apiHost, hostType: 'manual', hostEnv: 'live', hostRole: 'primary' }))
  api.setHost(details.apiHost)
  store.dispatch(registerDevice(details.participantId, details.team, details.playerSlot === 1, store.getState().ui.sideBarFontSize, details.token))
  store.dispatch(participantDetails(participantDetailsToSave))
}

export function registerWeb (details) {
  return async (dispatch, getState) => {
    dispatch(updateHost({ hostname: details.apiHost, hostType: 'manual', hostEnv: 'live', hostRole: 'primary' }))
    api.setHost(details.apiHost)
    api.setGameId(details.eventId)

    let isMaster = details.playerSlot === 1
    // let deviceRegistered = false
    try {
      const response = await api.getDevice(details.participantId)
      isMaster = response.isMaster
      // deviceRegistered = true
    } catch (e) {
      // console.log('error', e)
      // Device not setup yet, thats ok, ignore and move on
    }

    // if not registered get the last saved isMaster status
    // if (!deviceRegistered) {
    //   try {
    //     let deviceSetup = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
    //     deviceSetup = JSON.parse(deviceSetup)
    //     if (details.eventId === deviceSetup.gameId && Object.prototype.hasOwnProperty.call(deviceSetup, 'isMaster')) {
    //       isMaster = deviceSetup.isMaster
    //     }
    //   } catch (e) {}
    // }
    dispatch(registerDevice(details.participantId, details.team, isMaster, getState().ui.sideBarFontSize, null, { retryAsNonMaster: true }))
    dispatch(fetchContent())
  }
}

export async function init (store) {
  if (Platform.OS === 'web') {
    return
  }

  let deviceId = null
  let gameId = null
  let shouldFetchDeviceInfo = false
  try {
    let deviceSetup = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
    deviceSetup = JSON.parse(deviceSetup)
    deviceId = deviceSetup.deviceId
    gameId = deviceSetup.gameId
    if (gameId) {
      api.setGameId(gameId)
      store.dispatch(updateGameId(gameId))
    }
    if (deviceSetup.hostname) {
      const { hostname, hostType, hostEnv, hostRole } = deviceSetup
      store.dispatch(updateHost({ hostname, hostType, hostEnv, hostRole }))
      api.setHost(deviceSetup.hostname)
      store.dispatch(getGames(deviceSetup.hostname))
    } else {
      const { hostname, hostType, hostEnv, hostRole } = store.getState().device
      store.dispatch(updateHost({ hostname, hostType, hostEnv, hostRole }))
      api.setHost(hostname)
      store.dispatch(getGames(hostname))
    }
    if (deviceId && gameId && deviceSetup.team) {
      store.dispatch(fetchContent())
      store.dispatch(updateSetupInfo(true))
    }
  } catch (e) {
    console.log(e)
    api.setHost(hostname)
    store.dispatch(getGames(hostname))
  }

  if (deviceId && gameId) {
    shouldFetchDeviceInfo = true
  } else {
    deviceId = uuidv4()
    await AsyncStorage.setItem(DEVICE_SETUP_STORAGE_KEY, JSON.stringify({ deviceId }))
  }

  store.dispatch(initDeviceId(deviceId))
  if (shouldFetchDeviceInfo) {
    try {
      const deviceInfo = await api.getDevice(deviceId)
      store.dispatch(fetchContent())
      store.dispatch(registerDeviceSuccess(deviceInfo))
    } catch (e) {}
  }
}

export function updateDeviceMaster (isMaster) {
  return async (dispatch) => {
    let deviceSetup = await AsyncStorage.getItem(DEVICE_SETUP_STORAGE_KEY)
    deviceSetup = JSON.parse(deviceSetup)
    await AsyncStorage.setItem(DEVICE_SETUP_STORAGE_KEY, JSON.stringify({ ...deviceSetup, isMaster }))
    dispatch(setMasterStatus(isMaster))
  }
}
